var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-select',{attrs:{"placeholder":""},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},_vm._l((_vm.categories),function(cat){return _c('el-option',{key:cat.id,attrs:{"label":cat.label,"value":cat}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }